<template>
    <div>
        <table class="mt-4 table table-borderless">
            <tbody>
            <tr>
                <td class="w-25 p-1">
                    <p class="name text-secondary text-black-50 mt-4 mb-1">DOKUMENTMALL</p>
                </td>
                <td class="w-75 p-1">
                    <p class="name text-secondary text-black-50 mt-4 mb-1">OM MALLEN</p>
                </td>
            </tr>
            <tr>
                <td class="w-25 p-1">
                    <p class="title">Konkurrentjämförelse</p>
                </td>
                <td class="w-75 p-1">
                    <p class="value">Dokumentet baserar sig på officiella bokslut från tre utvalda bolag.</p>
                    <p class="value">Presentationen inkluderar femårsöversikt av nettoomsättningen och balansräkningen för bolagen. Dessutom finns detaljerade balans- och resultatdiagram i procentform för det senaste året för vart och ett av bolagen. Presentationen avslutas med en bolagskompass.</p>
                </td>
            </tr>
            </tbody>
        </table>

        <hr/>

        <table class="mt-4 mb-2 table table-borderless">
            <tbody>
            <tr>
                <td class="w-25 p-1">
                    <I name="compare" class="h1 mr-4 cSecondary"/>
                    <span class="h4">1. Välj bolag:</span>
                </td>
                <td class="w-75 p-1">
                    <CompanySelection
                        :disabled="editing"
                        :disabledSource="editing"
                        :useBranch="false"
                        :company="company"
                        @company="selectedCompany = $event"
                        @source="selectedSource = $event"
                        @branch="selectedBranch = $event" />
                    <div class="name text-secondary text-black-50 mb-1" style="opacity: 0.70;">KONKURRENT 1</div>
                    <v-select class="mb-4" v-model="selectedCompetitor1" :options="getCompanies()">
                        <span slot="no-options">Inga träffar....</span>
                    </v-select>
                    <div class="name text-secondary text-black-50 mb-1" style="opacity: 0.70;">KONKURRENT 2</div>
                    <v-select class="mb-4" v-model="selectedCompetitor2" :options="getCompanies()">
                        <span slot="no-options">Inga träffar....</span>
                    </v-select>
                </td>
            </tr>
            </tbody>
        </table>

        <hr class="mt-4"/>

        <table class="mt-4 table table-borderless">
            <tbody>
            <tr>
                <td width="240px" class="p-0 pt-2">
                    <div @click="$emit('prev')" class="btn btn-outline-danger btn-block btn-lg cursor-pointer">
                        <template v-if="!editing">RADERA UTKAST</template>
                        <template v-else>AVBRYT ÄNDRINGAR</template>
                    </div>
                </td>
                <td class="h3 text-center">&nbsp;</td>
                <td width="240px" class="p-0 pt-2">
                    <div @click="create()" class="btn btn-outline-primary btn-block btn-lg cursor-pointer" :class="{disabled: !canCreate()}">
                        <template v-if="!editing">SKAPA DOKUMENT</template>
                        <template v-else>UPPDATERA DOKUMENT</template>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
/* tslint:disable */

    import ValueGroup from '@/views/ValueGroup.vue'
    import ValueSelection from '@/views/ValueSelection';
    import CompanySelection from '@/components/CompanySelection';
    import user from '@/store/modules/user';
    import * as api from '@/store/api';

    export default {
        name: "CreateDocumentCompetitors",
        components: {ValueSelection, ValueGroup, CompanySelection},
        props: {
            doc: Object,
        },
        data () {
            return {
                selectedCompany: undefined,
                selectedSource: undefined,
                selectedCompetitor1: undefined,
                selectedCompetitor2: undefined,
                company: null,
                documentId: '',
            }
        },
        async mounted() {
            if (this.editing) {
                const c = await user.getCompany(this.doc.OrgNr);

                if (c) {
                    this.company = {
                        value: c.OrgNr,
                        label: c.Name,
                        Branch: c.Bransch,
                        BranchText: c.BranschText,
                        dateTo: c.DateTo,
                        SieAggVersion: this.doc.SieAggVersion,
                    };
                }

                if (this.doc.Competitor1) {
                    const c1 = await user.getCompany(this.doc.Competitor1);
                    if (c1) {
                        this.selectedCompetitor1 = {value: c1.OrgNr, label: c1.Name, bransch: c1.Bransch, branschText: c1.BranschText};
                    }
                }
                if (this.doc.Competitor2) {
                    const c2 = await user.getCompany(this.doc.Competitor2);
                    if (c2) {
                        this.selectedCompetitor2 = {value: c2.OrgNr, label: c2.Name, bransch: c2.Bransch, branschText: c2.BranschText};
                    }
                }
            }
        },
        methods: {
            canCreate() {
                // console.log(this.selectedCompany, this.selectedSource, this.selectedCompetitor1);
                return this.selectedCompany && this.selectedSource && this.selectedCompetitor1;
            },
            async create() {
                if (!this.canCreate()) return;
                let OrgNr = this.selectedCompany.value;
                const doc = {
                    Type: 'competitors',
                    OrgNr: OrgNr,
                    BasedOn: this.selectedSource.source,
                    SieAggVersion: this.selectedSource.id,
                    Competitor1: this.selectedCompetitor1.value,
                    Competitor1Name: this.selectedCompetitor1.label,
                    Competitor2: this.selectedCompetitor2 ? this.selectedCompetitor2.value : '',
                    Competitor2Name: this.selectedCompetitor2 ? this.selectedCompetitor2.label : '',
                    DocumentId: this.editing ? this.doc.DocumentId : '',
                };
                if (this.editing) {
                    await api.updateDocument(doc);
                    await user.getUser('Uppdaterar dokument');
                } else {
                    await api.addDocument(doc);
                    await user.getUser('Skapar dokument');
                }
                this.$router.push({ name: 'documents', params: { OrgNr } });
            },
            getCompanies() {
                return this.companies;
            },
            getBranches() {
                return [{id: 1, label: 'Branschen'}];
            },
        },
        computed: {
            companies() {
                const x = user.companies;
                let res = [];
                for (let y in x) {
                    let c = x[y];
                    if (c.DateTo) {
                        res.push({value: c.OrgNr, label: c.Name, bransch: c.Bransch, branschText: c.BranschText});
                    }
                }
                res.sort((a,b) => {
                    return ('' + a.label).localeCompare(b.label);
                });
                return res;
            },
            editing() {
                return this.$router.currentRoute.name === 'editdocument';
            },
        }
    }
</script>

<style scoped>
    .title {
        font-size: 1.5rem;
        font-weight: 600;
    }
    .name {
        font-size: 0.875rem;
        color: gray;
        text-transform: uppercase;
        font-weight: 400;
    }
    .value {
        font-size: 1.25rem;
        font-weight: 400;
    }
</style>
